import React from "react";

const TabButtons = ({ activeTab, openPage }) => {
    const tabs = ["day", "week", "month", "year", "all"];

    return (
        <div className="postsMenu">
            {tabs.map((tab) => {
                
                return (
                    <button
                        key={tab}
                        className={`tablink ${activeTab === tab ? "active" : ""}`}
                        onClick={() => openPage(tab)}
                    >
                       {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                );
            })}
        </div>
    );
};

export default TabButtons;
